import { Flower2, Headphones, Home, Monitor, Sparkles, Tag } from 'lucide-react';
import type { Category } from '@pricymayky/shared';
import { useState } from 'react';

const icons = { headphones: Headphones, monitor: Monitor, home: Home, sparkles: Sparkles };

export function ProductThumb({ category, imageUrl, size = 'md',name='' }: { category: Category; imageUrl: string | null; size?: 'sm' | 'md' | 'lg';name?:string }) {
  const [failedUrl,setFailedUrl]=useState<string|null>(null);
  const Icon = icons[category.icon as keyof typeof icons] ?? (category.slug.includes('miesz') ? Flower2 : Tag);
  const sizes = size === 'sm' ? 'size-10 rounded-lg' : size === 'lg' ? 'size-20 rounded-2xl sm:size-28' : 'size-14 rounded-xl';
  return <div className={`${sizes} relative flex shrink-0 items-center justify-center overflow-hidden border border-border bg-gradient-to-br from-muted to-card text-primary`}>
    {imageUrl && imageUrl!==failedUrl ? <img src={imageUrl} alt={name} loading="lazy" decoding="async" referrerPolicy="no-referrer" onError={()=>setFailedUrl(imageUrl)} className="size-full bg-white object-contain p-1" /> : <Icon className={size === 'lg' ? 'size-11' : 'size-5'} strokeWidth={1.7} />}
  </div>;
}
